import { render } from "./Checkout.vue?vue&type=template&id=51bd343f"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "51bd343f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51bd343f', script)) {
    api.reload('51bd343f', script)
  }
  
  module.hot.accept("./Checkout.vue?vue&type=template&id=51bd343f", () => {
    api.rerender('51bd343f', render)
  })

}

script.__file = "src/views/payments/modules/checkout/Checkout.vue"

export default script